<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="specialInspectsBinds"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button
            slot="toolbar"
            type="primary"
            size="mini"
            @click="$refs.editSpecialBind.open(0)">
          新建
        </el-button>
        <el-button
            slot="toolbar"
            type="success"
            plain
            size="mini"
            @click="downloadExcelSpecial">
          特殊工单导入模板
        </el-button>
        <el-upload
            action=""
            multiple
            :http-request="submitUpload"
            :show-file-list="false"
            :disabled="uploadLoading"
            style="display: inline-block;">
          <el-button type="primary" plain>
            <i class="el-icon-upload el-icon--right"/>
            特殊工单导入
          </el-button>
        </el-upload>

        <el-button
            slot="toolbar"
            type="success"
            plain
            size="mini"
            @click="downloadExcelChange">
          变更工单导入模板
        </el-button>
        <el-upload
            action=""
            multiple
            :http-request="submitUpload2"
            :show-file-list="false"
            :disabled="uploadLoading2"
            style="display: inline-block;">
          <el-button type="primary" plain>
            <i class="el-icon-upload el-icon--right"/>
            变更工单导入
          </el-button>
        </el-upload>
        <el-button :loading="exportLoading" type="primary" @click="exportExcel()">
          导出特殊检验报告
        </el-button>


        <el-input
            ref="searchInput"
            v-model.trim="filter.filter"
            class="search-bar"
            clearable
            style="width: 260px;float: right;"
            placeholder="请输入"
            @keyup.enter.native="handleSearch">
          <el-button slot="append" icon="el-icon-search" @click="handleSearch">
            查询
          </el-button>
        </el-input>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="检验类型">
            <el-select v-model.trim="filter.inspectType" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.specialInspectsBindType)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="PC号">
            <el-input v-model.trim="filter.pcNo" clearable/>
          </vm-search>
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.customerName" clearable/>
          </vm-search>
          <vm-search label="物料号">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="pcNo" align="center" label="pc号"/>
      <el-table-column prop="customerName" align="center" label="客户名称"/>
      <el-table-column prop="materialNo" align="center" label="物料号"/>
      <el-table-column prop="inspectType" align="center" label="检验类型">
        <template slot-scope="scope">
          {{ constant.specialInspectsBindType[scope.row.inspectType] || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" align="center" label="创建时间"/>
      <el-table-column prop="creatorName" align="center" label="创建人"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="edit(scope.row)">编辑</el-button>
          <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <special-inspects-bind-edit ref="editSpecialBind" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "../../../util/constant";
  import constants from "@/util/constants";
  import Preview from "@/views/purchase/inspectionReport/Preview";
  import InspectionReportEdit from "@/views/purchase/inspectionReport/InspectionReportEdit";
  import SpecialInspectsBindEdit from "@/views/purchase/specialInspectsBind/SpecialInspectsBindEdit";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "InspectionReportList",
    components: {SpecialInspectsBindEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        constants,
        uploadLoading: false,
        uploadLoading2: false,
        // uploadUrlSpecialInspects: window.config.basicServerUrl + "specialInspectsBinds/importExcel_special",
        // uploadUrlChangeInspects: window.config.basicServerUrl + "specialInspectsBinds/importExcel_change",
        show: "",
        exportLoading: false,
        exportLoading1: false,
        submitLoading: false,
        filter: {
          filter: "",
          inspectType: "",
          pcNo: "",
        },
        details: [],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleSearch() {
        this.getList(1);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "specialInspects/exportSpecialInspect", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "specialInspectsBinds/importExcel_special", formData)
          .then((res) => {
            this.uploadLoading = false;
            this.getList(1);
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      submitUpload2(params) {
        this.uploadLoading2 = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "specialInspectsBinds/importExcel_change", formData)
          .then((res) => {
            this.uploadLoading2 = false;
            this.getList(1);
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading2 = false;
            this.$message.error("上传失败");
          });
      },
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
      downloadExcelSpecial() {
        window.open("/publicFile/特殊工单模板.xlsx");
      },
      downloadExcelChange() {
        window.open("/publicFile/变更工单模板.xlsx");
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","specialInspectsBinds", row.pkid).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      edit(row) {
        this.$refs.editSpecialBind.open(row.pkid);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
